import {StyleSheet} from 'react-native';

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load.
const makeStyles = colors =>
  StyleSheet.create({
    container: {
      marginHorizontal: 24,
      marginTop: 16,
      borderRadius: 16,
      padding: 12,
      backgroundColor: colors.surface,
      shadowColor: colors.shadow,
      shadowOpacity: 0.12,
      shadowRadius: 30,
      shadowOffset: {width: 0, height: 30},
      flexDirection: 'row',
    },
    productImage: {
      height: 100,
      width: 100,
    },
    titleContainer: {
      marginLeft: 16,
      flex: 1,
      justifyContent: 'space-between',
    },
    priceContainer: {
      paddingHorizontal: 8,
      paddingVertical: 5,
      borderRadius: 8,
      backgroundColor: colors.backgroundMuted,
      alignSelf: 'flex-start',
    },
    freeContainer: {
      paddingVertical: 5,
      alignSelf: 'flex-start',
    },
    optionContainer: {
      borderRadius: 16,
      paddingHorizontal: 16,
      // react-native-popup-menu defaults to a white sheet; theme it so the
      // menu is legible in dark (light stays #fff — pixel-identical).
      backgroundColor: colors.surfaceElevated,
    },
    optionWrapper: {
      paddingVertical: 16,
      borderBottomColor: colors.border,
      borderBottomWidth: 1,
    },
    paddingVertical16: {
      paddingVertical: 16,
    },
    p10: {
      padding: 10,
    },
  });

export default makeStyles;
